export const ADD_TO_CART = 'add_to_cart';
export const GET_TOTAL = 'get_total';
export const REMOVE_TO_CART = 'remove_to_cart';
